package com.example.hukakmp.counter

import kotlinx.browser.window

private const val COUNTER_KEY = "huka_fish_counter_v1"

actual object FishCounterPersistence {
    actual fun load(): String? = window.localStorage.getItem(COUNTER_KEY)

    actual fun save(value: String) {
        window.localStorage.setItem(COUNTER_KEY, value)
    }

    actual fun clear() {
        window.localStorage.removeItem(COUNTER_KEY)
    }
}
